export default function Marquee() {
  const items = [
    'Journey maps',
    'Chaos → connection → solutions',
    'AI enthusiast',
    'Ube grounded',
    'Land I own',
    'A door, not a plea',
    'Survey verbatims',
    'The 62% matcher',
  ];
  const row = [...items, ...items];
  return (
    <section
      className="relative py-14 md:py-20 overflow-hidden border-y border-ink/10 bg-paper"
      data-testid="marquee-section"
      aria-hidden="true"
    >
      <div className="flex whitespace-nowrap animate-marquee">
        {row.map((t, i) => (
          <span key={i} className="serif italic text-ink text-[7vw] md:text-[5vw] px-8 md:px-14 leading-none">
            {t}
            <span className="mx-6 md:mx-10 text-orchid not-italic">✦</span>
          </span>
        ))}
      </div>
    </section>
  );
}
